import { type ReactNode, useContext } from 'react';

import PageContext from '@/Providers/PageContextProvider/PageContext';
import PageMeta from '@/shared/components/PageMeta';
import type { Props as PageMetaProps } from '@/shared/components/PageMeta';

import styles from './index.module.scss';
import { cn } from '@/lib/utils';

type Props = {
  readonly children: ReactNode;
  readonly pageMeta: PageMetaProps;
};

const FirstScreenLayout = ({ children, pageMeta }: Props) => {
  const { platform } = useContext(PageContext);

  return (
    <>
      <PageMeta {...pageMeta} />
      <div className={cn(styles.wrapper,
        'flex-1 flex flex-col justify-start lg:justify-center'
      )}>{children}</div>
    </>
  );
};

export default FirstScreenLayout;
